import React, { useState, useEffect } from "react";
import {
  getProviderSMSConversation,
  sendProviderSMS,
} from "apiHandler/actions";
import { useUserData } from "components/customHooks/userDataContext";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

const Chat = (props) => {
  const [selectedFile, setSelectedFile] = useState([]);
  const [lengthData, setLengthData] = useState(0);
  const [text, setText] = useState("");
  const [oldChat, setoldChat] = useState([]);
  const userData = useUserData();
  const token = userData?.access_token;

  const changeHandler = (event) => {
    if (event.target.files.length) {
      const a = [...event.target.files];
      setSelectedFile(a);
      setLengthData(event.target.files.length);
    }
  };

  const fetchMessages = async () => {
    const payload = {
      practice_id: userData.selected_practice,
      participant_number: props.provider_phone_mobile.toString(),
    };
    const chat = await getProviderSMSConversation(payload, token);
    setoldChat(chat ? chat.messages : []);
  };

  useEffect(() => {
    fetchMessages();
  }, [props.provider_phone_mobile]);

  const onSubmit = async (e) => {
    e.preventDefault();
    let payloadOne = {
      participant_number: props.provider_phone_mobile.toString(),
      author_name: userData.first_name + " " + userData.last_name,
      recipient_name: props.display_name,
      message_body: text,
    };

    let payloadTwo = {
      participant_number: props.provider_phone_mobile.toString(),
      author_name: userData.first_name + " " + userData.last_name,
      recipient_name: props.display_name,
    };
    console.log("selectedFile---", typeof selectedFile, selectedFile);
    const formData = new FormData();
    formData.append(
      "request_json",
      JSON.stringify(text.length ? payloadOne : payloadTwo)
    );

    selectedFile?.forEach((file) => {
      formData.append(`file`, file, file.name);
    });

    const response = await sendProviderSMS(formData, token);
    if (response) {
      setLengthData(0);
      fetchMessages();
    }
  };

  return (
    <div className="chat-cont">
      <div className="chat-title">
        {props.first_name +
          " " +
          props.last_name +
          "  " +
          props.provider_phone_mobile}
      </div>
      <main className="chat-main">
        {oldChat.length < 1 ? (
          <span>No data found</span>
        ) : (
          <div>
            {oldChat.map(function (item, index) {
              return (
                <div
                  key={index}
                  style={{
                    textAlign:
                      item.author === userData.last_name ||
                      item.author ===
                        userData.first_name + " " + userData.last_name
                        ? "right"
                        : "left",
                    paddingRight: "20px",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    {item.media_url?.map((data, key) => {
                      return (
                        <a
                          key={key}
                          rel="noreferrer"
                          href="https://thumbs.dreamstime.com/b/beautiful-rain-forest-ang-ka-nature-trail-36703721.jpg"
                          target="_blank"
                        >
                          <img
                            src="https://thumbs.dreamstime.com/b/beautiful-rain-forest-ang-ka-nature-trail-36703721.jpg"
                            alt="response"
                            width="50"
                            height="50"
                          />
                        </a>
                      );
                    })}
                  </div>
                  <span
                    style={{
                      backgroundColor:
                        item.author === userData.last_name ||
                        item.author ===
                          userData.first_name + " " + userData.last_name
                          ? "#bbdefb"
                          : "#98fb98",
                    }}
                  >
                    {item.body}
                    <sup style={{ fontSize: "8px", paddingLeft: "5px" }}>
                      {item.date_created.slice(0, 22)}
                    </sup>
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </main>
      <form className="chat-footer">
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="chat-textarea"
          placeholder="Type a message"
        />
        <Tooltip title="Attach File">
          <IconButton
            color="primary"
            aria-label="upload picture"
            component="label"
          >
            <input
              hidden
              type="file"
              name="file"
              onChange={changeHandler}
              multiple
            />
            <PhotoCameraIcon />
          </IconButton>
        </Tooltip>
        <button
          className="chat-submit"
          onClick={onSubmit}
          style={{ float: "right" }}
        >
          Send
        </button>
        {lengthData ? (
          <p>
            {lengthData === 1
              ? `${lengthData} File selected`
              : `${lengthData} Files selected`}
          </p>
        ) : null}
      </form>
    </div>
  );
};

export default Chat;
